import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthguardService } from '../authentication/services/authguard/authguard.service';
import { MainmenuComponent } from '../mainmenu/mainmenu.component';
import { HistoryMapComponent } from './history-map/history-map.component';

const routes: Routes = [
  { 
    path: 'sistema', component: MainmenuComponent,
    children: [
      {
        path: 'history', component: HistoryMapComponent,
      }
    ],
    canActivate: [AuthguardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HistoryAnalysisRoutingModule { }
